// extracted by mini-css-extract-plugin
export default {"container":"Training_container__Lm5-t","smallText":"Training_smallText__XZfwI","left":"Training_left__DB8av","right":"Training_right__LXS5D"};